<template>
  <div :data-color="backgroundColor"
       data-image="''"
       class="sidebar">
    <div class="sidebar-wrapper">
      <div class="logo">
        <router-link class="simple-text logo__container" to="/">
          <div class="logo-img">
            <img alt="" src="/img/cyto-logo.png">
          </div>
          {{ title }}
        </router-link>
      </div>

      <slot name="content"></slot>
      <ul class="nav nav-main__links">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot>
          <sidebar-link v-for="(link,index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link"
                        :to="link.path"
                        @click="closeNavbar">
            <i :class="link.icon"></i>
            <p>{{ link.name }}</p>
          </sidebar-link>
        </slot>
      </ul>
      <ul v-if="$slots['bottom-links']" class="nav nav-bottom">
        <slot name="bottom-links"></slot>
      </ul>
    </div>
  </div>
</template>
<script>
import SidebarLink from './SidebarLink.vue';

export default {
  components: {
    SidebarLink,
  },
  props: {
    title: {
      type: String,
      default: 'Cyto Scriba',
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: (value) => {
        let acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black'];
        return acceptedValues.indexOf(value) !== -1;
      },
    },

    activeColor: {
      type: String,
      default: 'success',
      validator: (value) => {
        let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  computed: {},
  methods: {},
};

</script>
<style>
.sidebar .sidebar-wrapper {
  display: flex;
  flex-direction: column;
}

.sidebar .nav-main__links {
  flex: 1;
}


.sidebar .sidebar-wrapper .logo .logo__container {
  padding-left: 10px;
  text-decoration: none;
  font-weight: bold;
}

.sidebar .sidebar-wrapper .logo .logo__container:hover {
  text-decoration: underline;
}
</style>
